/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
  name: 'UiFormPartial',

  template: `
    <div class="ui-form-partial">
      <div class="ui-form-partial__header" slot="header" v-if="label || $slots.label">
        <div class="ui-form-partial__header__label">
          <slot name="label">{{ label }}</slot>
        </div>
        <div v-if="sublabel || $slots.sublabel" class="ui-form-partial__header__sublabel">
          <slot name="sublabel">{{ sublabel }}</slot>
        </div>
      </div>
      
      <div class="ui-form-partial__body">
        <slot></slot>
      </div>
    </div>
  `,

  props: {
    label: {
      type: String,
      default: '',
    },
    sublabel: {
      type: String,
      default: '',
    },
  },
};

